import { authApi } from '../apis/auth/auth.api.ts'
import { tickerManagementApi } from '../apis/ticker-management/ticker-management-api.api.ts'
import { userManagementApi } from '../apis/user-management/user-management-api.api.ts'
import { optionApi } from '../apis/option/option-api.api.ts'
import { firmManagementApi } from '../apis/firm-management/firm-management-api.api.ts'
import { rankingApi } from '../apis/ranking/ranking-api.api.ts'
import { ideaApi } from '../apis/idea/idea-api.api.ts'
import { tickerApi } from '../apis/ticker/ticker-api.api.ts'
import { bookApi } from '../apis/book/book-api.api.ts'
import { statisticsApi } from '../apis/statistics/statistics-api.api.ts'
import { blockLeaveApi } from '../apis/block-leave/block-leave-api.api.ts'
import { positionApi } from '../apis/position/position-api.api.ts'
import { mailListApi } from '../apis/mail-list/mail-list-api.api.ts'
import { authMiddleware } from './middleware/auth.middleware.ts'
import { unauthorizedMiddleware } from './middleware/unauthorized.middleware.ts'

const extraMiddleware = [
  authApi.middleware,
  bookApi.middleware,
  tickerManagementApi.middleware,
  userManagementApi.middleware,
  firmManagementApi.middleware,
  ideaApi.middleware,
  tickerApi.middleware,
  optionApi.middleware,
  rankingApi.middleware,
  statisticsApi.middleware,
  blockLeaveApi.middleware,
  positionApi.middleware,
  mailListApi.middleware,
  authMiddleware,
  unauthorizedMiddleware,
]

export default extraMiddleware
